'use strict';

var cov_2jpyxg49db = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/auth/auth.run.js',
        hash = 'e2e586a7921ec3c02d67901cfe7b2572309fc1bd',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/auth/auth.run.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 24,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 23
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 13,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 12,
                    column: 35
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 9
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 12
                },
                end: {
                    line: 21,
                    column: 15
                }
            },
            '7': {
                start: {
                    line: 18,
                    column: 16
                },
                end: {
                    line: 18,
                    column: 47
                }
            },
            '8': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 62
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 24,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 76
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 33
                    },
                    end: {
                        line: 10,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 50
                    },
                    end: {
                        line: 14,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 17,
                        column: 56
                    },
                    end: {
                        line: 17,
                        column: 57
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 68
                    },
                    end: {
                        line: 19,
                        column: 13
                    }
                },
                line: 17
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 19,
                        column: 15
                    },
                    end: {
                        line: 19,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 19,
                        column: 27
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                },
                line: 19
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                }],
                line: 11
            },
            '1': {
                loc: {
                    start: {
                        line: 11,
                        column: 16
                    },
                    end: {
                        line: 11,
                        column: 133
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 11,
                        column: 16
                    },
                    end: {
                        line: 11,
                        column: 30
                    }
                }, {
                    start: {
                        line: 11,
                        column: 35
                    },
                    end: {
                        line: 11,
                        column: 62
                    }
                }, {
                    start: {
                        line: 11,
                        column: 66
                    },
                    end: {
                        line: 11,
                        column: 94
                    }
                }, {
                    start: {
                        line: 11,
                        column: 98
                    },
                    end: {
                        line: 11,
                        column: 132
                    }
                }],
                line: 11
            },
            '2': {
                loc: {
                    start: {
                        line: 16,
                        column: 8
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 16,
                        column: 8
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                }, {
                    start: {
                        line: 16,
                        column: 8
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                }],
                line: 16
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0, 0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2jpyxg49db.s[0]++;
(function () {
    'use strict';

    cov_2jpyxg49db.f[0]++;
    cov_2jpyxg49db.s[1]++;
    angular.module('app').run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state, $auth, AuthService, $transitions) {
        cov_2jpyxg49db.f[1]++;
        cov_2jpyxg49db.s[2]++;

        $transitions.onStart({}, function (trans) {
            cov_2jpyxg49db.f[2]++;
            cov_2jpyxg49db.s[3]++;

            if ((cov_2jpyxg49db.b[1][0]++, !$rootScope.me) && (cov_2jpyxg49db.b[1][1]++, trans.to().name !== 'login') && (cov_2jpyxg49db.b[1][2]++, trans.to().name !== 'forgot') && (cov_2jpyxg49db.b[1][3]++, trans.to().name !== 'set_password')) {
                cov_2jpyxg49db.b[0][0]++;
                cov_2jpyxg49db.s[4]++;

                $state.go("login");
            } else {
                cov_2jpyxg49db.b[0][1]++;
            }
        });

        cov_2jpyxg49db.s[5]++;
        if ($auth.isAuthenticated()) {
            cov_2jpyxg49db.b[2][0]++;
            cov_2jpyxg49db.s[6]++;

            AuthService.refreshAuthenticatedInfo().then(function () {
                cov_2jpyxg49db.f[3]++;
                cov_2jpyxg49db.s[7]++;

                $rootScope.refreshMeTaskData();
            }, function () {
                cov_2jpyxg49db.f[4]++;
                cov_2jpyxg49db.s[8]++;

                AuthService.logout().then($state.go('login'));
            });
        } else {
            cov_2jpyxg49db.b[2][1]++;
        }
    }
})();